import http from 'common-module/src/util/http';

/* 添加/修改 指引信息 */
export async function addProductGuide(data) {
  return http.post('account/add-product-guide', data);
}

/* 获取指引信息 */
export async function loadProductGuide(data) {
  return http.post(`/account/query-product-guide?t=${Date.now()}`, data);
}

/* 根据目标选择初始化工作台 */
export async function initHomeWidget(targetChoice) {
  return http.post('/sys-home/init-home-widget', { targetChoice, reportProject:true });
}

// 记录指引已操作信息
export async function guideRecord(step) {
  return http.post('/account/guide-record', { guideType:step });
}

export async function queryGuideInfo() {
  return http.post('/account/query-guide-info', {}, { showError: false });
}

export async function queryWorthMsgGuide() {
  return http.get('/msg/query/worth-msg-guide');
}

export async function queryMilestoneWorthMsg() {
  return http.post('/msg/query/milestone-worth-msg');
}
//获取新手指引（根据用户选择的角色推荐）
export async function getGuideInstance() {
  return http.post('/account-preferences/get-guide-instance', {});
}
//是否选择过角色
export async function getConfigRole(){
  return http.post('/account-preferences/has-role', {});
}
//获取新手指引（根据用户选择的角色推荐）国内
export async function getZhGuideInstance() {
  return http.get('/account-preferences/v2/get-guide-instance');
}

// 获取新手指引所有新手任务（用于测试）
export async function getAllGuideTask() {
  return http.post('/account-preferences/v2/create-user-quest-for-test');
}
// 根据任务id更新任务状态
export async function guideUpdateStatus(id, status) {
  return http.get('/quest/update-status' + '?id=' + id + '&status=' + status) ;
}
